export default __webpack_public_path__ + "static/media/avatar-people-female-0006.wtn-site.svg";